var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:{ 'app-card-overlay': _vm.isOverlayActive }}),_c('div',{class:{ 'active-card': _vm.isOverlayActive }},[_vm._t("card")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }